module.exports = __webpack_public_path__ + "assets/img/login.22a45ea8.svg";